import React, { useEffect } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';

const Input = styled.input.attrs((props) => ({
    type: 'text',
    size: props.small ? 5 : undefined,
}))`
    height: 32px;
    width: 200px;
    border-radius: 3px;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    border: 1px solid #e5e5e5;
    padding: 0 32px 0 16px;
`;

const DataTableFilter = ({ filterText, onFilter, onClear, onUpdateFilter }) => {

    useEffect(() => {
        const delayDebounceFn = setTimeout(async () => {
            if(onUpdateFilter != null) onUpdateFilter();
        }, 1500)
    
        return () => clearTimeout(delayDebounceFn)
      }, [filterText])

    return (
        <>
            <Input
                id="search"
                type="text"
                placeholder="Filter table data..."
                value={filterText}
                onChange={onFilter}
            />
            <Button
                onClick={onClear}
                style={{ backgroundColor: 'gray', borderColor: 'gray' }}
            >
                X
            </Button>
        </>
    );
};
DataTableFilter.propTypes = {
    filterText: PropTypes.string.isRequired,
    onFilter: PropTypes.func.isRequired,
    onClear: PropTypes.func.isRequired,
};
export default DataTableFilter;
